import { render, staticRenderFns } from "./Collect1.vue?vue&type=template&id=d4003e5a&scoped=true"
import script from "./Collect1.vue?vue&type=script&lang=js"
export * from "./Collect1.vue?vue&type=script&lang=js"
import style0 from "./Collect1.vue?vue&type=style&index=0&id=d4003e5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4003e5a",
  null
  
)

export default component.exports